import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { UtilsService } from '../services/utils/utils.service';
import { DocumentService } from '../services/documents/document.service';
import { AppSettings } from '../Constant/AppSettings';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  items: MenuItem[] = [{ label: 'Terms-and-conditions' }];
  home: MenuItem = { icon: 'pi pi-home', routerLink: '/home' };

  documentsList: any[] = [];
  previewUrl: SafeResourceUrl | null = null;

  selectedFile: File | null = null;

  isLoading = false;
  disabled = false;

  displayUploadDialog = false;

  innerWidth!: number;
  dialogWidth = '50vw';
  @ViewChild('fileInput') fileInput!: ElementRef;
  documentType = 'TERMS_OF_USE';
  

  constructor(
    public utils: UtilsService,
    private documentService: DocumentService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    this.setDialogWidth();
    this.loadDocuments();
  }

  setDialogWidth() {
    if (this.innerWidth <= 640) {
      this.dialogWidth = '95vw';
    } else if (this.innerWidth <= 1024) {
      this.dialogWidth = '75vw';
    } else {
      this.dialogWidth = '50vw';
    }
  }

  get state(): string {
    return this.utils.state;
  }

  openUploadDialog() {
    this.displayUploadDialog = true;
  }

  clearFormData() {
    this.selectedFile = null;

    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  loadDocuments() {

  this.documentService.listDocuments(this.documentType).subscribe({

    next: (response: any) => {

      if (response.response.status === 'SUCCESS') {
        this.documentsList = [response.data];  // <-- FIX
      }else{
        this.documentsList = [];
      }

    },

    error: () => {
      this.showErrorToastMsg(AppSettings.ERROR_MSG);
    }

  });

}

  selectFile(event: any) {

    const file = event.target.files[0];

    if (file) {
      this.selectedFile = file;
    }

  }

  upload() {

    if (!this.selectedFile) return;

    this.showProgressBar();

    this.documentService.uploadDocument('TERMS_OF_USE', this.selectedFile)
      .subscribe({

        next: (res: any) => {

          this.hideProgressBar();

          this.showSuccessMessage(res.response.status, res.response.message);

          this.displayUploadDialog = false;

          this.clearFormData();

          this.loadDocuments();

        },

        error: () => {

          this.hideProgressBar();

          this.showErrorToastMsg(AppSettings.ERROR_MSG);

        }

      });

  }


  confirmDeleteDialog(type: string) {

  this.messageService.clear();

  this.confirmationService.confirm({
    message: 'Do you want to delete this document?',
    header: 'Delete Confirmation',
    icon: 'pi pi-trash',

    accept: () => {
      this.delete(type);
    }

  });

}

  delete(type: string) {

  this.documentService.deleteDocument(type).subscribe({

    next: (res: any) => {

      this.showSuccessMessage(res.response.status, res.response.message);

      this.loadDocuments();

    },

    error: () => {

      this.showErrorToastMsg(AppSettings.ERROR_MSG);

    }

  });

}

  preview(type: string) {

    this.documentService.getDocumentViewUrl(type)
      .subscribe((response: any) => {

        if (response.response.status === 'SUCCESS') {

          const url = environment.IMAGE_BASE_URL + 'previewpdf/' + response.data.fileName;

          this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        }

      });

  }

  showProgressBar() {
    this.messageService.clear();
    this.isLoading = true;
    this.disabled = true;
  }

  hideProgressBar() {
    this.isLoading = false;
    this.disabled = false;
  }


  showErrorMessage(msg: string) {
    this.messageService.add({
      key: 'errMsg',
      severity: 'error',
      detail: msg,
    });
  }

  showErrorToastMsg(msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'error',
      detail: msg,
    });
  }

  showSuccessMessage(status: string, msg: string) {
    this.messageService.add({
      key: 'br',
      severity: 'success',
      summary: status,
      detail: msg,
    });
  }

  showDialogMaximized(event: any, dialog: Dialog) {
    if (this.innerWidth <= 640) {
      dialog.maximized = true;
    }
  }

}